import { postForm } from '../api/form.js';
import { getUTM } from './getUTM';

function getFormInputs(form) {
  return Object.values(form).reduce((obj, field) => {
    if (field.name && field.value) {
      obj[field.name] = field.value;
    }
    return obj;
  }, {});
}

function disableForm(form) {
  const fieldsets = form.querySelectorAll('fieldset');
  fieldsets.forEach((fieldset) =>
    fieldset.setAttribute('disabled', 'disabled'),
  );

  const loader = form.querySelector('.form__loader');
  if (loader) loader.removeAttribute('hidden');
}

function enableForm(form) {
  const fieldsets = form.querySelectorAll('fieldset');
  fieldsets.forEach((fieldset) => fieldset.removeAttribute('disabled'));

  const loader = form.querySelector('.form__loader');
  if (loader) loader.setAttribute('hidden', 'hidden');
}

/**
 * Submits form to wordpress ajax.
 *
 * @param {Element} form
 * @param {Object} options
 * @param {function([])} options.onSubmit
 */
export function submitForm(form, options = {}) {
  if (!form) return;

  const defaultOptions = {
    onSubmit: (response, params) => {},
    onFailure: (response, params) => {},
  };
  options = { ...defaultOptions, ...options };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    disableForm(form);

    const inputs = getFormInputs(form);
    const utms = getUTM();
    const params = { ...inputs, ...utms, path: window.location.pathname };

    postForm(params)
      .then((response) => {
        enableForm(form);

        if (response.status === 'success') {
          options.onSubmit(response, params);
        } else {
          options.onFailure(response, params);
        }
      })
      .catch((err) => options.onFailure(err, params));
  });
}
